import type { ThreadsClientInterface } from './threadsClient.types';
import { threadsClientConfig } from './threadsClient.types';
import CorporateThreadsClient from './corporateThreadsClient';
import GroupThreadsClient from './groupThreadsClient';
import OrgUnitThreadsClient from './orgUnitThreadsClient';
import type { ClientContext } from '~/services/contextClient';

export default class ThreadsClientFactory {
    static createClient(context: ClientContext): ThreadsClientInterface {
        if (!context.orgUnitId && !context.groupId) {
            return new CorporateThreadsClient(context.teamId, threadsClientConfig);
        } else if (context.orgUnitId) {
            return new OrgUnitThreadsClient(context.teamId, context.orgUnitId, threadsClientConfig);
        } else if (context.groupId) {
            return new GroupThreadsClient(context.teamId, context.groupId, threadsClientConfig);
        }

        throw new Error('Invalid context');
    }
}
